
const app = {

	product_info: "Information produit",
	txid: "Transaction: ",
	show_info: "Plus d'information",
	track_info: "Information de suivi",
	meterial_info: "Information traçabilité",
	product_head: "Produit",
	show_head: "Info",
	track_head: "Suivi",
	meterial_head: "Traçabilité",

	valid_msg: "Part of the production process has been verified by DNV",
	message_tc_landingpage_NotAllowException: "Please contact your admin to open the access for the information",
	message_tc_landingpage_DataEmptyException: "Fail authentication",
	message_default: "Unreadable product information",
	sorry: "Error",
	download_msg: "You may check the verification information and more details of the product by using VeChain Pro.",
	download: "Download",
	mainnet: "Main",
	testnet: "Sandbox",
	mintText: 'NFT',
	simpleText: 'Chip Not Verified',
	track_info_multi: ' Records',
	track_info_single: ' Record',
	meterial_info_multi: ' Records',
	meterial_info_single: ' Record',
	custom_records_multi: ' Records',
	custom_records_single: ' Record',
	verify: {
		sku: "Product Information Verification",
		chip: "Anti-counterfeiting Verification",
		pass: "Pass",
		fail: "Fail",
		view: "View Landing Page",
		user: "Please contact the merchant for manual verification"
	},
	nft: {
		series: 'Series',
		createTime: 'Creation Time',
		owner: 'Owner',
		blockinfo: 'Blockchain Information',
		contractAddress: 'Contract Address'
	}
}

export default {
	app
}
